import { render, staticRenderFns } from "./avatar-item.vue?vue&type=template&id=7dbcb578&scoped=true&"
import script from "./avatar-item.vue?vue&type=script&lang=js&"
export * from "./avatar-item.vue?vue&type=script&lang=js&"
import style0 from "./avatar-item.vue?vue&type=style&index=0&id=7dbcb578&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbcb578",
  null
  
)

export default component.exports